import React, { FunctionComponent } from 'react'

import { useTheme } from 'styled-components/native'

import { CalendarAlert } from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { IconBadge } from '../../atoms/iconBadge/IconBadge'
import { AlertIconStroke } from '../../atoms/icons/AlertIconStroke'
import { PressableOpacity } from '../../atoms/pressableOpacity/PressableOpacity'
import { BadgeShape, BadgeVariant } from '../../badge/constants'
import { ThemeType } from '../../utils/themes/ThemeProvider'

export type ProviderCalendarMetricBadgeProps = {
  alert: CalendarAlert
  onPress?: () => void
  testID?: string
}

export const ProviderCalendarMetricBadge: FunctionComponent<ProviderCalendarMetricBadgeProps> = ({
  alert,
  onPress,
  testID,
}) => {
  const theme = useTheme() as ThemeType
  return (
    <PressableOpacity onPress={onPress} testID={testID}>
      <IconBadge
        frontIcon={<AlertIconStroke size={16} fillColor={theme.colors.textError} />}
        text={alert.badge}
        variant={BadgeVariant.ATTENTION}
        shape={BadgeShape.RECT}
      />
    </PressableOpacity>
  )
}
